<template>
  <div id="cover">
    <v-container class="max-height" v-scroll-reveal>
      <v-row class="flex-column align-center justify-center max-height">
        <div><h1 class="cover-lead">Ingatlan kivitelezés magas minőségben</h1></div>
        <div class="button-container"><v-btn outlined rounded large class="cover-button" @click="$vuetify.goTo('#contactContainer')">Érdekel</v-btn></div>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
#cover {
  background: url("../../assets/bg1.jpg") no-repeat no-repeat center;
  background-size: cover;
  height: 95vh;
  width: 100%;
}

.max-height {
  height: 100%;
}

.cover-lead {
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 200;
  letter-spacing: 0.2rem;
  text-align: center;
}

.button-container{
  margin-top: 5rem;
}

.cover-button {
  transform: scale(1.5);
  color: rgba(255, 255, 255, 0.75);
}

@media screen and (max-width: 600px) {
  .cover-lead {
  font-size: 2rem;
  }

  .cover-button {
  transform: scale(1.2);
}
}

</style>


<script>
export default {};
</script>
